import React, { CSSProperties } from 'react';

import styles from './Skeleton.module.scss';

type SkeletonProps = {
  className?: string;
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
  borderRadius?: CSSProperties['borderRadius'];
  animated?: boolean;
};

const Skeleton = ({ className, width, height, borderRadius, animated = true }: SkeletonProps) => {
  const style: CSSProperties = {
    width,
    height,
    borderRadius,
  };

  return (
    <div
      className={[styles.skeleton, className, !animated ? styles.static : '']
        .filter(Boolean)
        .join(' ')}
      style={style}
      aria-hidden="true"
    />
  );
};

export default Skeleton;
